export const footerListTitleIndex: { [key: string]: string } = {
  AboutUs: 'Features',
  Product: 'Support',
  Help: 'Communities',
  Study: 'Policies',
};
